import React from "react";
import PropTypes from "prop-types";

//
import { useTable, useSortBy } from "react-table";

//
import ScrollBar from "react-perfect-scrollbar";
import { Dropdown } from "react-bootstrap";

//
import ReactTable from "../general/ReactTable";
import ImageBox from "../general/ImageBox";

//
import { iconImage } from "../../redux/features/coins/actions";

function DesktopAssetsList({ items, delete_asset, showAssetTransactions }) {
  const delete_asset_group = (content) => {
    let symbol = content.symbol;
    let portfolioID = content.transactions[0].portfolio_id;

    delete_asset(symbol, portfolioID);
  };

  // begim::table
  const data = items;

  const columns = React.useMemo(
    () => [
      {
        Header: "Name",
        accessor: "symbol", // accessor is the "key" in the data
        Cell: (cellProps) => {
          let value = cellProps.value;

          return (
            <div className="d-flex align-items-center">
              {/* <ImageBox src={iconImage(value)} alt={value} /> */}
              <p className="text-black fw-bolder">{value}</p>
            </div>
          );
        },
      },
      {
        Header: "Price",
        accessor: "prices", // accessor is the "key" in the data
        Cell: (cellProps) => {
          let USDT = `${cellProps.row.original.prices.USDT}`;
          let usdtSplit = USDT.split(".");

          let BTC = `${cellProps.row.original.prices.BTC}`;
          let btcSplit = BTC.split(".");

          return (
            <div>
              <div className="d-flex align-items-center">
                <small className="text-black fw-bolder">${usdtSplit[0]}</small>
                {usdtSplit[1] && <small>.{usdtSplit[1]}</small>}
              </div>

              <div className="d-flex align-items-center">
                <small className="text-black fw-bolder">₿{btcSplit[0]}</small>
                {btcSplit[1] && <small>.{btcSplit[1]}</small>}
              </div>
            </div>
          );
        },
      },
      {
        Header: "24",
        accessor: "percent_change_24h", // accessor is the "key" in the data
        Cell: (cellProps) => {
          let USDT = cellProps.row.original.percent_change_24h.USDT;
          let BTC = cellProps.row.original.percent_change_24h.BTC;

          return (
            <div>
              <small
                className={`fw-bolder ${
                  +USDT > 0 ? "text-success" : "text-danger"
                }`}
              >
                {+USDT > 0 && "+"}
                {USDT}%
              </small>

              <small
                className={`fw-bolder ${
                  +BTC > 0 ? "text-success" : "text-danger"
                }`}
              >
                {+BTC > 0 && "+"}
                {BTC}%
              </small>
            </div>
          );
        },
      },
      {
        Header: "holding",
        accessor: "holding", // accessor is the "key" in the data
        Cell: (cellProps) => {
          let USDT = cellProps.row.original.holding.USDT;
          let BTC = cellProps.row.original.holding.BTC;
          let symbol = cellProps.row.original.symbol;
          let quantity = cellProps.row.original.quantity;

          return (
            <div>
              <small className="fw-bolder text-black">
                ${Number(USDT).toFixed(2)}
              </small>
              <small className="fw-bolder text-black">
                ₿{Number(BTC).toFixed(8)}
              </small>
              <small className="fw-bolder text-muted">
                {quantity} {symbol}
              </small>
            </div>
          );
        },
      },
      {
        Header: "AVG. BUY PRICE",
        accessor: "avgPrice", // accessor is the "key" in the data
        Cell: (cellProps) => {
          let USDT = cellProps.row.original.avgPrice.USDT;
          let BTC = cellProps.row.original.avgPrice.BTC;
          let symbol = cellProps.row.original.symbol;

          let usdtSplit = Number(USDT)
            .toFixed(symbol === "BTC" ? 2 : 8)
            .replace(/\.?0+$/, "")
            .split(".");

          let btcSplit = Number(BTC)
            .toFixed(symbol === "BTC" ? 2 : 8)
            .replace(/\.?0+$/, "")
            .split(".");

          return (
            <div>
              <div className="d-flex align-items-center">
                <small className="text-black fw-bolder">${usdtSplit[0]}</small>
                {usdtSplit[1] && <small>.{usdtSplit[1]}</small>}
              </div>

              <div className="d-flex align-items-center">
                <small className="text-black fw-bolder">₿{btcSplit[0]}</small>
                {btcSplit[1] && <small>.{btcSplit[1]}</small>}
              </div>
            </div>
          );
        },
      },
      {
        Header: "PROFIT/LOSS",
        accessor: "benefit", // accessor is the "key" in the data
        Cell: (cellProps) => {
          let usdtProfit = cellProps.row.original.benefit.USDT;
          let usdtPercent = cellProps.row.original.benefitPercent.USDT;

          let btcProfit = cellProps.row.original.benefit.BTC;
          let btcPercent = cellProps.row.original.benefitPercent.BTC;

          return (
            <div>
              <div className="d-flex align-items-center">
                <small className="fw-bolder text-black">
                  {+usdtProfit > 0 && "+"} ${usdtProfit}
                </small>

                <small
                  className={`ms-1 fw-bolder ${
                    +usdtPercent > 0 ? "text-success" : "text-danger"
                  }`}
                >
                  {+usdtPercent > 0 && "+"}
                  {usdtPercent}%
                </small>
              </div>

              <div className="d-flex align-items-center">
                <small className="fw-bolder text-black">
                  {+btcProfit > 0 && "+"} ₿{btcProfit}
                </small>

                <small
                  className={`ms-1 fw-bolder ${
                    +btcPercent > 0 ? "text-success" : "text-danger"
                  }`}
                >
                  {+btcPercent > 0 && "+"}
                  {btcPercent}%
                </small>
              </div>
            </div>
          );
        },
      },
      {
        Header: "",
        accessor: "coin_id",
        Cell: (cellProps) => {
          let content = cellProps.row.original;

          return (
            <Dropdown align="end" className="edit-dropdown">
              <Dropdown.Toggle className="no-border">
                <i className="las la-ellipsis-v"></i>
              </Dropdown.Toggle>
              <Dropdown.Menu>
                <ScrollBar>
                  <Dropdown.Item onClick={() => delete_asset_group(content)}>
                    <small className="text-danger d-flex align-items-center fw-bolder">
                      <i className="las la-trash text-danger"></i>
                      Delete
                    </small>
                  </Dropdown.Item>
                  <Dropdown.Item onClick={() => showAssetTransactions(content)}>
                    <small className="text-black d-flex align-items-center fw-bolder">
                      <i className="las la-edit"></i>
                      Transactions
                    </small>
                  </Dropdown.Item>
                </ScrollBar>
              </Dropdown.Menu>
            </Dropdown>
          );
        },
      },
    ],
    []
  );

  const { getTableProps, getTableBodyProps, headerGroups, rows, prepareRow } =
    useTable({ columns, data }, useSortBy);
  // end::table

  return (
    <ReactTable
      rows={rows}
      sort
      prepareRow={prepareRow}
      headerGroups={headerGroups}
      getTableProps={getTableProps}
      getTableBodyProps={getTableBodyProps}
    />
  );
}

DesktopAssetsList.propTypes = {
  items: PropTypes.array.isRequired,
  delete_asset: PropTypes.func.isRequired,
  showAssetTransactions: PropTypes.func.isRequired,
};

export default DesktopAssetsList;
